import { StyledWrapper } from "components/home/styling";
import styled from "styled-components";

export const StyledContentWrapper = styled(StyledWrapper)`
  padding-top: 4rem;
  background-color: var(--background-color);
  @media screen and (max-width: 992px) {
    padding-top: 2rem;
  }
`;
export const StyledHeader = styled.div`
  height: ${(props) => props.height || "400px"};
  width: 100%;
  position: relative;
  background-color: #fcfeff;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--text-color);
  @media screen and (max-width: 992px) {
    height: auto;
    padding-bottom: 2rem;
  }
  * {
    color: ${(props) => props["data-dark"] && "var(--text-color)"};
  }
`;
export const StyledHeaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 1280px;
  width: calc(100% - 4rem);
  height: 100%;
  @media screen and (max-width: 1280px) {
    flex-direction: column;
    align-items: flex-start;
    padding-top: 4rem;
  }
  @media screen and (max-width: 992px) {
    flex-direction: column;
  }
  @media screen and (max-width: 768px) {
    padding-top: 0;
  }
`;
export const StyledHeaderTitle = styled.h1`
  font-size: 3rem;
  line-height: 3.8rem;
  max-width: 100%;
  flex: 1;
  color: ${(props) => (props["data-dark"] ? "var(--text-color)" : "var(--text-color)")};
  @media screen and (max-width: 1280px) {
    display: flex;
    align-items: center;
  }
  @media screen and (max-width: 992px) {
    line-height: 4.2rem;
    font-size: 3rem;
  }
`;
export const StyledHeaderImage = styled.div`
  flex: 1;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: flex-end;
  margin-bottom: 2rem;
  flex-grow: 0;
  opacity: 0.6;
  svg {
    height: 75%;
    width: auto;
    fill: ${(props) => (props["data-single"] ? "var(--text-color)" : "rgba(255, 255, 255, .1)")};
    @media screen and (max-width: 992px) {
      display: none;
    }
  }
  path,
  g {
    fill: ${(props) => (props["data-single"] ? "var(--text-color)" : "rgba(255, 255, 255, .1)")};
  }
  @media screen and (max-width: 992px) {
    height: auto;
    width: 100%;
    max-width: 300px;
  }
`;
